/**
 * Опечатка в фамилии супруга или ребёнка (сверка «Айнбиндер», 26.10.2026:
 * в заявлении муж и дочь стали «Айбиндер»). Свидетельства о браке и
 * рождении приходят сканами, прочитать их нельзя — поэтому сверяется
 * сама фамилия: отличается от фамилии должника (у ребёнка — и супруга)
 * на одну-две буквы — похоже на опечатку.
 *
 * Мужская и женская форма опечаткой не считаются: Иванов / Иванова,
 * Достоевский / Достоевская.
 */

const surname = (fio: string) => (fio.trim().split(/\s+/)[0] ?? '').toLowerCase().replace(/ё/g, 'е');

/** Основа без родового окончания: «иванова» → «иванов», «достоевская» → «достоевск». */
const stem = (value: string) => value.replace(/(ая|ий|ой|ый)$/, '').replace(/а$/, '');

function distance(a: string, b: string): number {
  let prev = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i++) {
    const row = [i];
    for (let j = 1; j <= b.length; j++) row[j] = Math.min(prev[j]! + 1, row[j - 1]! + 1, prev[j - 1]! + (a[i - 1] === b[j - 1] ? 0 : 1));
    prev = row;
  }
  return prev[b.length]!;
}

/** Похожая, но не та же фамилия: вернёт фамилию, с которой она почти совпала. */
export function similarSurname(fio: string, others: string[]): string | null {
  const own = surname(fio);
  if (own.length < 4) return null;
  // Совпала с кем-то из семьи — не опечатка, даже если похожа на другого
  if (others.some((other) => stem(surname(other)) === stem(own))) return null;
  for (const other of others) {
    const theirs = surname(other);
    if (theirs.length < 4) continue;
    const d = distance(stem(own), stem(theirs));
    if (d >= 1 && d <= 2) return other.trim().split(/\s+/)[0]!;
  }
  return null;
}
